import { BatchPreviewDTO } from "src/app/_core/classes/BatchPreviewDTO";

export class FbAuctionDetailConfiguration {

    public batch : BatchPreviewDTO | null = null;

    public position: number | null = null;
    public extraCSS : string | null = null;
    public imageUrl: string;
    public seller: string;
    public time: number;
    public button: boolean;
    public buttonText: string;
    public imgSeller:string;
    constructor(batch : BatchPreviewDTO) {
        this.batch = batch;
        this.button=true;
        this.buttonText="RILANCIA"
    }

    public static create = (batch : BatchPreviewDTO) => new FbAuctionDetailConfiguration(batch);
     setImageUrl(value: string | null){
        this.imageUrl = value;
        return this;
     }

     setSeller(value: string | null) {
        this.seller = value;
        return this;
     }

     setTime(value: number | null){
        this.time = value;
        return this;
     }
     setButton(value: boolean | null){
        this.button = value;
        return this;
     }
     setButtonText(value: string | null){
        this.buttonText = value;
        return this;
     }
     setImgSeller(value: string | null){
        this.imgSeller = value;
        return this;
     }

     setPosition(value: number | null){
        this.position = value;
        return this;
     }
     setExtraCSS(value: string | null){
        this.extraCSS = value;
        return this;
     }
}
